import { Box } from '@mui/material';
import React from 'react';
import { ActionButton } from '../../ActionButton';
export const MainActionsMedium = (props) => {
    if (props.mainAction && props.secondaryAction) {
        return (React.createElement(Box, { sx: { display: 'grid', gridTemplateColumns: (theme) => `repeat(2, calc(50% - ${theme.spacing(1)}))`, gap: 2 } },
            React.createElement(ActionButton, { action: props.secondaryAction, variant: 'outlined', "default-data-test": 'secondary-action-button' }),
            React.createElement(ActionButton, { action: props.mainAction, variant: 'contained', "default-data-test": 'main-action-button' })));
    }
    else if (props.mainAction) {
        return React.createElement(ActionButton, { action: props.mainAction, fullWidth: true, variant: 'contained', "default-data-test": 'main-action-button' });
    }
    else if (props.secondaryAction) {
        return React.createElement(ActionButton, { action: props.secondaryAction, fullWidth: true, variant: 'outlined', "default-data-test": 'secondary-action-button' });
    }
    else {
        return null;
    }
};
